export default {
    ADD_INSTANCE: 'ADD_INSTANCE',
    EDIT_INSTANCE: 'EDIT_INTSANCE',
    DELETE_INSTANCE: 'DELETE_INSTANCE',
    UPDATE_FULL_INSTANCES: 'UPDATE_FULL_INSTANCES',
    RESET_INSTANCES: 'RESET_INSTANCES'
};
